<template>
    <DataTable
            ref="dataTable"
            v-redirect-if-no-permission:DEMAND_PUMP
            title="Demand Pump Monitor"
            :url="api.ACTIONS.DEMAND_PUMP"
            :fields-hidden-main='[]'
            :enable-delete="false"
            :enable-add="false"
            :enable-edit="false"/>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';

    export default {
        name: "Index",
        title: 'Demand Pump Index',
        components: {DataTable}
    }
</script>

<style scoped>

</style>